import axios from 'axios';

const { apiHost = '' } = window.hichatConfig || {};
const wootAPI = axios.create({ baseURL: `${apiHost}/` });

export default wootAPI;
